import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TagsInput } from "react-tag-input-component";
import ColumnResizer from "react-table-column-resizer";
import { nanoid } from "nanoid";
import Dropdown from "react-bootstrap/Dropdown";
import Popover from "@mui/material/Popover";
import { ModalAllder } from "layouts/ModalAllder";
import { NumericFormat } from "react-number-format";
import CurrencyInput from "react-currency-input-field";
import { PRPrint } from "layouts/PrintPR";
import { useReactToPrint } from "react-to-print";
import { ProductHistory } from "layouts/ProductHistory";
import { ModalProductReceive } from "layouts/ModalproductReceive";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { arrayMove, SortableContext, verticalListSortingStrategy, useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useAppDispatch, useAppSelector } from "../../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllMstPaymentType } from "../../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstPriceCategory } from "../../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstDiscountType } from "../../../redux/handlers/master/getAllMstDiscountType.handler";
import { initState } from "mocks/grData";
import moment from "moment";
import { getAllSupplierInformation } from "../../../redux/handlers/logic/getAllSupplierInformation.handler";
import { getAllWarehouse } from "../../../redux/handlers/master/getAllWarehouse.handler";
import { getAllMstVat } from "../../../redux/handlers/master/getAllMstVat.handler";
import { NumberFormat, NumberFormatFloat, WDA, calPriceByMstCategoryPriceTax, calPriceByMstCategoryPriceTaxSeparate, getDiscountValue, getEmpFullNameTHByEmpData, getGP, getTotalPriceWithNewQty, isReadyToPrint, mappingOptionNewItemPrCol, safeDivide } from "utils/HelperFunction";
import { getAllMstNewItemPrCol } from "../../../redux/handlers/master/getAllMstNewItemPrCol.handler";
import { LoadDocument } from "layouts/LoadDucuments";
import { ProductSelect } from "layouts/ProductSelect";
import { ProductTableSort } from "layouts/ProductTableSort";
import { ProductTableDisplay } from "layouts/ProductTableDisplay";
import { getUserInfo } from "../../../redux/handlers/auth/getUserInfo.handler";
import AddIcon from "@mui/icons-material/Add";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import { ModalAdditionalCosts } from "layouts/ModalAdditionalCost";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { getExVatAvgPriceByExpenseType, getFinanJsonKeyValue, isDisabledEditFinancial, mappingFinancial, mappingProductItemUpdate } from "utils/HelperFinancialFunction";
import { getNewGrById } from "../../../redux/handlers/logic/getNewGrById.handler";
import { clearUpdateNewGr, updateNewGr } from "../../../redux/handlers/logic/updateNewGr.handler";
import FinancialTotal from "fragments/FinancialTotal";
import FinancialDiffStatus from "fragments/FinancialDiffStatus";
import FinancialStatus from "fragments/FinancialStatus";
import DiscountInput from "fragments/DiscountInput";
import { getAllMstExpenseType } from "../../../redux/handlers/master/getAllMstExpenseType.handler";
import DiffStatus from "fragments/DiffStatus";
import { FormControl } from "react-bootstrap";
import { ProductTableFilterDisplay } from "layouts/ProductTableFilterDisplay";
export function CheckGoodsReceipt() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var dataID = useParams().dataID;
    var _useState = _sliced_to_array(useState([]), 2), productRow = _useState[0], setProductRow = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductPrice = _useState1[0], setSumproductPrice = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState2[0], setSumproductNoVat = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState3[0], setSumproductZeroVat = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState4[0], setSumproductSevenVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState5[0], setSumproductBeforeVat = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumproductOrdered = _useState6[0], setSumproductOrdered = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumProductadditionalcosts = _useState7[0], setSumProductadditionalcosts = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), totalInDiscoutExVat = _useState8[0], setTotalInDiscoutExVat = _useState8[1];
    var _useState9 = _sliced_to_array(useState(false), 2), isDiffPO = _useState9[0], setIsDiffPO = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), updateDocIds = _useState10[0], setUpdateDocIds = _useState10[1];
    var _useState11 = _sliced_to_array(useState({
        columnsort: [
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            },
            {
                id: "",
                sortKey: ""
            }
        ],
        type: "select"
    }), 2), columnsort = _useState11[0], setColumnsort = _useState11[1];
    var schema = yup.object().shape({
        doc_due_date: yup.string().required(),
        dim_mst_price_category_id: yup.string().required(),
        dim_mst_payment_type_id: yup.string().required(),
        update_gr_items: yup.array().of(yup.object().shape({
            dim_warehouse_id: yup.string().required("Warehouse ID is required.")
        })),
        dim_mst_financial_status_id: yup.string().required(),
        dim_mst_expense_type_id: yup.string().when([], {
            is: function() {
                return additionalCost.length > 0;
            },
            then: function(schema) {
                return schema.required();
            }
        }),
        edit_financial_reason: yup.string().when([], {
            is: function() {
                return modalEditFinancial.open;
            },
            then: function(schema) {
                return schema.required();
            }
        })
    });
    var _useState12 = _sliced_to_array(useState(true), 2), formdisabled = _useState12[0], setFormdisabled = _useState12[1];
    var _useState13 = _sliced_to_array(useState(initState), 2), formdata = _useState13[0], setFormdata = _useState13[1];
    var _useState14 = _sliced_to_array(useState(""), 2), docDate = _useState14[0], setDocDate = _useState14[1];
    var _useState15 = _sliced_to_array(useState(""), 2), docDueDate = _useState15[0], setDocDueDate = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        id: "",
        dimGroupOfSupplierCode: "",
        full_supplier_name: "-",
        initials: "-",
        company_branch_code: "",
        company_branch_name: "",
        full_supplier_address_name: "-",
        company_phone_number: "-"
    }), 2), pdata = _useState16[0], setPdata = _useState16[1];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.full_supplier_name
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#8E8E8F"
                    },
                    children: item.initials
                })
            ]
        }, item.id);
    };
    var _useState17 = _sliced_to_array(useState(1), 2), tab = _useState17[0], setTab = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), tagselected = _useState18[0], setTagSelected = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), attachments = _useState19[0], setAttachments = _useState19[1];
    var handlePreviewFile = function(e, itemIndex) {
        if (e.target.files[0]) {
            var reader = new FileReader();
            var file = e.target.files[0].name.split(".");
            var blobUrl = URL.createObjectURL(e.target.files[0]);
            reader.addEventListener("load", function() {
                var newId = nanoid();
                setAttachments(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: newId,
                            docId: "",
                            docFile: e.target.files[0].name,
                            docFileType: file[1],
                            docFileData: reader.result,
                            docUrl: blobUrl
                        }
                    ]);
                });
                e.target.value = "";
            });
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    var deleteDocument = function(removeId) {
        setAttachments(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
    };
    var _useState20 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success"
    }), 2), modalSuccess = _useState20[0], setModalSuccess = _useState20[1];
    var _useState21 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "success2"
    }), 2), modalApproveRequestSuccess = _useState21[0], setModalApproveRequestSuccess = _useState21[1];
    var _useState22 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 360,
        height: 320,
        pin: false,
        mode: "normal",
        modalname: "savesuccess2"
    }), 2), modalSaveSuccess = _useState22[0], setModalSaveSuccess = _useState22[1];
    var _useState23 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalApproveSuccess = _useState23[0], setModalApproveSuccess = _useState23[1];
    var _useState24 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalNotApprove = _useState24[0], setModalNotApprove = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 410,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalEditFinancial = _useState25[0], setModalEditFinancial = _useState25[1];
    var _useState26 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 310,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalAlert = _useState26[0], setModalAlert = _useState26[1];
    var _useState27 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 360,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirmCancel = _useState27[0], setModalConfirmCancel = _useState27[1];
    var _useState28 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false
    }), 2), columdisplay = _useState28[0], setColumDisplay = _useState28[1];
    var _useState29 = _sliced_to_array(useState({
        onlyReceiveProduct: {
            isActive: false,
            name: "แสดงเฉพาะสินค้ารับแล้ว"
        }
    }), 2), filterDisplay = _useState29[0], setFilterDisplay = _useState29[1];
    var loadAllMsts = function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllWarehouse());
        dispatch(getAllMstNewItemPrCol());
        dispatch(getAllMstExpenseType());
    };
    var loadAllResources = function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(getAllSupplierInformation({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState30 = _sliced_to_array(useState([]), 2), optionsMstPaymentType = _useState30[0], setOptionsMstPaymentType = _useState30[1];
    var _useState31 = _sliced_to_array(useState([]), 2), optionsMstPriceCategory = _useState31[0], setOptionsMstPriceCategory = _useState31[1];
    var _useState32 = _sliced_to_array(useState([]), 2), optionsMstDiscountType = _useState32[0], setOptionsMstDiscountType = _useState32[1];
    var _useState33 = _sliced_to_array(useState([]), 2), optionsMstVat = _useState33[0], setOptionsMstVat = _useState33[1];
    var _useState34 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState34[0], setOptionsWarehouse = _useState34[1];
    var _useState35 = _sliced_to_array(useState([]), 2), optionNewItemPrCol = _useState35[0], setOptionNewItemPrCol = _useState35[1];
    var _useState36 = _sliced_to_array(useState([]), 2), optionsMstExpenseType = _useState36[0], setOptionsMstExpenseType = _useState36[1];
    var _useState37 = _sliced_to_array(useState(), 2), userInfo = _useState37[0], setUserInfo = _useState37[1];
    var _useState38 = _sliced_to_array(useState([]), 2), updateExpenseIds = _useState38[0], setUpdateExpenseIds = _useState38[1];
    var getAllMstPaymentTypeReducer = useAppSelector(function(state) {
        return state.getAllMstPaymentTypeReducer;
    });
    var getAllMstPriceCategoryReducer = useAppSelector(function(state) {
        return state.getAllMstPriceCategoryReducer;
    });
    var getAllMstDiscountTypeReducer = useAppSelector(function(state) {
        return state.getAllMstDiscountTypeReducer;
    });
    var getAllMstVatReducer = useAppSelector(function(state) {
        return state.getAllMstVatReducer;
    });
    var getAllWarehouseReducer = useAppSelector(function(state) {
        return state.getAllWarehouseReducer;
    });
    var getAllMstNewItemPrColReducer = useAppSelector(function(state) {
        return state.getAllMstNewItemPrColReducer;
    });
    var getAllMstExpenseTypeReducer = useAppSelector(function(state) {
        return state.getAllMstExpenseTypeReducer;
    });
    var getUserInfoReducer = useAppSelector(function(state) {
        return state.getUserInfoReducer;
    });
    useEffect(function() {
        loadAllMsts();
        loadAllResources();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstPaymentTypeReducer.isFetching || getAllMstPriceCategoryReducer.isFetching || getAllMstDiscountTypeReducer.isFetching || getAllMstVatReducer.isFetching || getUserInfoReducer.isFetching || getAllMstExpenseTypeReducer.isFetching);
        if (getUserInfoReducer.data) {
            setUserInfo(getUserInfoReducer.data.data);
        }
        if (getAllMstPaymentTypeReducer.data) {
            setOptionsMstPaymentType(getAllMstPaymentTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstPriceCategoryReducer.data) {
            setOptionsMstPriceCategory(getAllMstPriceCategoryReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstDiscountTypeReducer.data) {
            setOptionsMstDiscountType(getAllMstDiscountTypeReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstVatReducer.data) {
            setOptionsMstVat(getAllMstVatReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }));
        }
        if (getAllWarehouseReducer.data) {
            setOptionsWarehouse(getAllWarehouseReducer.data.data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id
                };
            }));
        }
        if (getAllMstNewItemPrColReducer.data) {
            var optionsMap = mappingOptionNewItemPrCol(getAllMstNewItemPrColReducer.data.data);
            setOptionNewItemPrCol(optionsMap);
        }
        if (getAllMstExpenseTypeReducer.data) {
            setOptionsMstExpenseType(getAllMstExpenseTypeReducer.data.data);
        }
    }, [
        getAllMstPaymentTypeReducer,
        getAllMstPriceCategoryReducer,
        getAllMstDiscountTypeReducer,
        getAllMstVatReducer,
        getAllWarehouseReducer,
        getAllMstNewItemPrColReducer,
        getUserInfoReducer,
        getAllMstExpenseTypeReducer
    ]);
    var genNewGrDocNumberReducer = useAppSelector(function(state) {
        return state.genNewGrDocNumberReducer;
    });
    var _useState39 = _sliced_to_array(useState([]), 2), supplierInfos = _useState39[0], setSupplierInfos = _useState39[1];
    var getAllSupplierInformationReducer = useAppSelector(function(state) {
        return state.getAllSupplierInformationReducer;
    });
    useEffect(function() {
        setIsLoading(genNewGrDocNumberReducer.isFetching || getAllSupplierInformationReducer.isFetching);
        if (genNewGrDocNumberReducer.data) {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: genNewGrDocNumberReducer.data.data
                });
            });
        }
        if (getAllSupplierInformationReducer.data) {
            setSupplierInfos(getAllSupplierInformationReducer.data.data);
        }
    }, [
        genNewGrDocNumberReducer,
        getAllSupplierInformationReducer
    ]);
    var getNewGrByIdReducer = useAppSelector(function(state) {
        return state.getNewGrByIdReducer;
    });
    var getData = function() {
        dispatch(getNewGrById(dataID, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var _useState40 = _sliced_to_array(useState("ตรวจเอกสารใบรับสินค้า"), 2), headerName = _useState40[0], setheaderName = _useState40[1];
    useEffect(function() {
        if (dataID) {
            getData();
        // setFormdata(testState)
        } else {
            setFormdata(initState);
        }
    }, [
        dataID
    ]);
    useEffect(function() {
        setIsLoading(getNewGrByIdReducer.isFetching);
        if (getNewGrByIdReducer.data && !getNewGrByIdReducer.isError && dataID) {
            var grData = getNewGrByIdReducer.data.data;
            if (!grData) {
                return navigate("/404", {
                    replace: true
                });
            }
            var action = "edit";
            var dataWithReplacements = mappingFinancial({
                grData: grData,
                action: action,
                setPdata: setPdata,
                setProductRow: setProductRow,
                setFormdisabled: setFormdisabled,
                columnsort: columnsort,
                setColumnsort: setColumnsort,
                setAttachments: setAttachments,
                setTagSelected: setTagSelected,
                setAdditionalCost: setAdditionalCost
            });
            setFormdata(dataWithReplacements);
        }
    }, [
        getNewGrByIdReducer
    ]);
    var updateNewGrReducer = useAppSelector(function(state) {
        return state.updateNewGrReducer;
    });
    useEffect(function() {
        setIsLoading(updateNewGrReducer.isFetching);
        if (updateNewGrReducer.data && !updateNewGrReducer.isError) {
            setModalNotApprove(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalEditFinancial(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalConfirmSave(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            setModalConfirm(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
            getData();
            setModalSuccess(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: true
                });
            });
            dispatch(clearUpdateNewGr());
            setFormdisabled(true);
        }
    }, [
        updateNewGrReducer
    ]);
    useEffect(function() {
        if (dataID) {
            var deleteCandidateDocIds = formdata.dimDocFilePr ? formdata.dimDocFilePr.map(function(item) {
                return item.id;
            }) : [];
            var deleteDocIds = deleteCandidateDocIds.filter(function(docId) {
                return !attachments.some(function(doc) {
                    return doc.docId === docId;
                });
            });
            var allDocIds = _to_consumable_array(deleteDocIds);
            console.log("All Doc IDs to update or delete:", allDocIds);
            setUpdateDocIds(allDocIds);
        }
    }, [
        dataID,
        attachments
    ]);
    var componentRef = useRef();
    var handlePrint = useReactToPrint({
        content: function() {
            return componentRef.current;
        }
    });
    var _useState41 = _sliced_to_array(useState(true), 2), Collapse = _useState41[0], setCollapse = _useState41[1];
    var _useState42 = _sliced_to_array(useState([]), 2), productReceive = _useState42[0], setProductReceive = _useState42[1];
    var _useState43 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1000,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-receive"
    }), 2), modalProductReceive = _useState43[0], setModalProductReceive = _useState43[1];
    var _useState44 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 280,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirm = _useState44[0], setModalConfirm = _useState44[1];
    var _useState45 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 460,
        height: 280,
        pin: false,
        mode: "normal",
        modalname: "apsuccess2"
    }), 2), modalConfirmSave = _useState45[0], setModalConfirmSave = _useState45[1];
    var _useState46 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1000,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "AdditionalCosts"
    }), 2), modalAdditionalCosts = _useState46[0], setModalAdditionalCosts = _useState46[1];
    var _useState47 = _sliced_to_array(useState([]), 2), additionalCost = _useState47[0], setAdditionalCost = _useState47[1];
    var _useState48 = _sliced_to_array(useState(false), 2), editDocRefNumber = _useState48[0], setEditDocRefNumber = _useState48[1];
    var _useState49 = _sliced_to_array(useState(false), 2), editDocRefDate = _useState49[0], setEditDocRefDate = _useState49[1];
    return /*#__PURE__*/ _jsxs("div", {
        className: "document-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-1",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "การเงินและบัญชี"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "GR Review"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        headerName,
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 ",
                        children: "ตรวจเอกสารใบรับสินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                onSubmit: function(values) {
                    var _loop = function(key) {
                        if (Object.hasOwnProperty.call(values, key)) {
                            var value = values[key];
                            if (keyJsonList.includes(key) && value) {
                                formdataPayload.append(key, JSON.stringify(value));
                            } else if (Array.isArray(value)) {
                                value.forEach(function(item) {
                                    return formdataPayload.append(key, item);
                                });
                            } else if (value !== undefined) {
                                formdataPayload.append(key, value);
                            }
                        }
                    };
                    // console.log(values.dim_mst_discount_type_id);
                    // console.log(values.discount_value);
                    // console.log(values.discount_price);
                    var formdataPayload = new FormData();
                    var keyJsonList = getFinanJsonKeyValue();
                    for(var key in values)_loop(key);
                    if (dataID) {
                        dispatch(updateNewGr(dataID, formdataPayload, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            var product = productRow.filter(function(prev) {
                                return prev.productCode !== "";
                            });
                            var isExpenseMatch = additionalCost.length > 0 && NumberFormatFloat(sumProductadditionalcosts, 4) !== NumberFormatFloat(additionalCost.reduce(function(sum, item) {
                                return sum + (item.total_price_before_vat || 0);
                            }, 0), 4);
                            if (isExpenseMatch) {
                                return;
                            }
                            if (product && product.length > 0) {
                                var newItems = mappingProductItemUpdate(product);
                                schema.validate(_object_spread_props(_object_spread({}, values), {
                                    dim_new_purchase_req_items: newItems
                                }), {
                                    abortEarly: false
                                }).then(function() {
                                    setFieldValue("doc_files", attachments.map(function(v) {
                                        return v.docFileData;
                                    }));
                                    setFieldValue("updateExpenseIds", additionalCost.map(function(v) {
                                        return v.id;
                                    }));
                                    setFieldValue("update_gr_items", newItems);
                                    setFieldValue("tag_grs", tagselected);
                                    if (dataID) {
                                        setFieldValue("update_doc_ids", updateDocIds);
                                    }
                                    handleSubmit();
                                }).catch(function(err) {
                                    console.log(err);
                                });
                            } else {
                                setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            }
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-0 pagezoom",
                                        style: {
                                            maxWidth: "700px"
                                        }
                                    }),
                                    dataID && values.financialEditedByEmp && /*#__PURE__*/ _jsxs("div", {
                                        className: "edit-warn pagezoom mb-4",
                                        children: [
                                            /*#__PURE__*/ _jsx("img", {
                                                src: "/images/icon-warn-orange.png"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-16",
                                                children: "".concat(moment(values.financial_edited_at, "YYYY-MM-DD HH:mm:ss").add(7, "hours").format("DD/MM/YYYY HH:mm:ss"), " โดย ").concat(getEmpFullNameTHByEmpData(values.financialEditedByEmp), " “").concat(values.edit_financial_reason, "”")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card pagezoom card-st-3 mb-4",
                                        style: {
                                            minWidth: "1000px"
                                        },
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                id: "",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "pt-3 px-3",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "row g-xl-4",
                                                            children: [
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "เลขที่ใบรับสินค้า",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                href: "/goods-receipt/edit/".concat(values.id),
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                className: "underline text-[#565DFF]",
                                                                                children: values.doc_number
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "เอกสารอ้างอิง",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "flex items-center",
                                                                            children: !editDocRefNumber ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "text-[#2192FF] mr-2",
                                                                                        children: values.refer
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(IconButton, {
                                                                                        className: "!bg-[#FF6B00] disabled:!bg-[#333] w-[21px] h-[21px]",
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setEditDocRefNumber(true);
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(ModeEditOutlineOutlinedIcon, {
                                                                                            className: "text-[#FFF]  mt-[-2px] !text-[18px] p-[2px]"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Control, {
                                                                                        type: "text",
                                                                                        name: "refer",
                                                                                        className: "form-control h-[44px] mr-3",
                                                                                        placeholder: "",
                                                                                        value: values.refer,
                                                                                        onChange: handleChange,
                                                                                        isInvalid: !!errors.refer
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(IconButton, {
                                                                                        className: "!bg-[#FF6B00] w-[34px] h-[34px] ml-3 !rounded-[8px]",
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setEditDocRefNumber(false);
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(SaveIcon, {
                                                                                            className: "text-[#FFF] mt-[-2px] !text-[18px] p-[2px]"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(IconButton, {
                                                                                        className: "!bg-[#FFF] border-solid border-2 w-[34px] h-[34px] !rounded-[8px]",
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setEditDocRefNumber(false);
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(CloseIcon, {
                                                                                            className: "text-[#000] mt-[-2px] !text-[18px] p-[2px]"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "วันที่เอกสารอ้างอิง",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "flex items-center",
                                                                            children: editDocRefDate ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx(Form.Group, {
                                                                                        className: "form-st-3 !my-0 pb-1",
                                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                                            className: "pr-[15px]",
                                                                                            children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                                inputFormat: "DD/MM/YYYY",
                                                                                                selected: docDate,
                                                                                                onChange: function(date) {
                                                                                                    setDocDate(date);
                                                                                                    setFieldValue("refer_date", moment(date).format("YYYY-MM-DD"));
                                                                                                },
                                                                                                placeholder: "DD/MM/YYYY",
                                                                                                className: "w-100 h-[44px] datepicker2 ".concat(values.refer_date ? "" : !!errors.refer_date ? "is-invalid" : ""),
                                                                                                value: values.refer_date ? moment(values.refer_date).format("DD/MM/YYYY") : ""
                                                                                            })
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(IconButton, {
                                                                                        className: "!bg-[#FF6B00] w-[34px] h-[34px] ml-3 !rounded-[8px]",
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setEditDocRefDate(false);
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(SaveIcon, {
                                                                                            className: "text-[#FFF] mt-[-2px] !text-[18px] p-[2px]"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(IconButton, {
                                                                                        className: "!bg-[#FFF] border-solid border-2 w-[34px] h-[34px] !rounded-[8px]",
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setEditDocRefDate(false);
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(CloseIcon, {
                                                                                            className: "text-[#000] mt-[-2px] !text-[18px] p-[2px]"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "text-[#2192FF] mr-2",
                                                                                        children: values.refer_date ? moment(values.refer_date).format("DD/MM/YYYY") : "-"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx(IconButton, {
                                                                                        className: "!bg-[#FF6B00] disabled:!bg-[#333] w-[21px] h-[21px]",
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setEditDocRefDate(true);
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(ModeEditOutlineOutlinedIcon, {
                                                                                            className: "text-[#FFF] mt-[-2px] !text-[18px] p-[2px]"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "อ้างอิงจากระบบ",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("a", {
                                                                                href: "/purchase/order/edit/".concat(values.orderID),
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                className: "underline text-[#565DFF]",
                                                                                children: values.po_split_refer
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "วันที่จัดส่ง",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#2192FF]",
                                                                            children: moment(values.delivery_date).format("DD/MM/YYYY")
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-2",
                                                                    children: /*#__PURE__*/ _jsx("div", {
                                                                        className: "d-flex justify-content-end align-items-center h-100",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx(FinancialStatus, {
                                                                                statusID: values.financialStatusID,
                                                                                statusName: values.financialStatusName,
                                                                                docDueDate: values.doc_due_date
                                                                            })
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "บริษัท",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#2192FF]",
                                                                            children: values.full_supplier_name
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "ที่อยู่",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#2192FF]",
                                                                            children: values.full_supplier_address_name
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "เบอร์โทร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#2192FF]",
                                                                            children: values.supplier_phone_number
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "ชื่อย่อ",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#2192FF]",
                                                                            children: values.supplier_nickname
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "จุดรับสินค้า",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#4C4E64]/[0.87]",
                                                                            children: values.dim_warehouse_name
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "วันที่รับสินค้า",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#4C4E64]/[0.87]",
                                                                            children: values.delivery_date ? moment(values.doc_receive_date).format("DD/MM/YYYY") : ""
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "เวลาที่รับสินค้า",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#4C4E64]/[0.87]",
                                                                            children: values.doc_receive_time
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "ผู้รับสินค้า",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#4C4E64]/[0.87]",
                                                                            children: getEmpFullNameTHByEmpData(values.createdNewGrEmp)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-3",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-3 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "ครบกำหนดชำระ",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "pr-[15px]",
                                                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                                                    inputFormat: "DD/MM/YYYY",
                                                                                    selected: docDueDate,
                                                                                    onChange: function(date) {
                                                                                        setDocDueDate(date);
                                                                                        setFieldValue("doc_due_date", moment(date).format("YYYY-MM-DD"));
                                                                                    },
                                                                                    placeholder: "DD/MM/YYYY",
                                                                                    className: "w-100 datepicker2 ".concat(values.doc_due_date ? "" : !!errors.doc_due_date ? "is-invalid" : ""),
                                                                                    value: values.doc_due_date ? moment(values.doc_due_date).format("DD/MM/YYYY") : ""
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium ",
                                                                            children: [
                                                                                "ค่าใช้จ่ายเพิ่มเติม",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        additionalCost.length > 0 ? additionalCost.map(function(item, index) {
                                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                                className: "text-[#565DFF] w-fit min-w-[190px] min-h-[40px] px-3 font-bold  bg-[#E0EBFF] mb-2 rounded-lg flex items-center",
                                                                                children: [
                                                                                    item.doc_number,
                                                                                    !formdisabled && /*#__PURE__*/ _jsx(IconButton, {
                                                                                        "aria-label": "close",
                                                                                        onClick: function() {
                                                                                            setAdditionalCost(function(prev) {
                                                                                                return prev.filter(function(item2) {
                                                                                                    return item2.id !== item.id;
                                                                                                });
                                                                                            });
                                                                                        },
                                                                                        children: /*#__PURE__*/ _jsx(CancelRoundedIcon, {
                                                                                            className: "text-[#565DFF]"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            });
                                                                        }) : /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsxs(Button, {
                                                                                className: "btn btn-link text-[18px] px-0 no-underline text-[#FF6B00] disabled:!bg-[#FFF]",
                                                                                onClick: function() {
                                                                                    setModalAdditionalCosts(function(prev) {
                                                                                        return _object_spread_props(_object_spread({}, prev), {
                                                                                            open: true
                                                                                        });
                                                                                    });
                                                                                },
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ _jsx(AddIcon, {}),
                                                                                    " เพิ่มใบบันทึกค่าใช้จ่าย"
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-2",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "text-lg font-medium mb-1",
                                                                            children: [
                                                                                "มูลค่า (Ex.Vat)",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "text-[#4C4E64]/[0.87]",
                                                                            children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                                                displayType: "text",
                                                                                thousandSeparator: ",",
                                                                                decimalScale: 2,
                                                                                fixedDecimalScale: true,
                                                                                value: additionalCost.reduce(function(sum, item) {
                                                                                    return sum + (item.total_price_before_vat || 0);
                                                                                }, 0)
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ _jsxs("div", {
                                                                    className: "col-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "pt-3",
                                                                            children: optionsMstExpenseType.map(function(v) {
                                                                                return /*#__PURE__*/ _jsx(Form.Check, {
                                                                                    inline: true,
                                                                                    label: v.name,
                                                                                    name: "dim_mst_expense_type_id",
                                                                                    type: "radio",
                                                                                    className: "form-check-st-2 tc-7",
                                                                                    value: v.id,
                                                                                    checked: values.dim_mst_expense_type_id === v.id,
                                                                                    onChange: function(e) {
                                                                                        console.log(e.currentTarget.value);
                                                                                        setFieldValue("dim_mst_expense_type_id", parseInt(e.currentTarget.value));
                                                                                    },
                                                                                    disabled: additionalCost.length === 0 || formdisabled,
                                                                                    isInvalid: !!errors.dim_mst_expense_type_id
                                                                                }, "mn-radio-".concat(v.id));
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Check, {
                                                                            className: "mt-2",
                                                                            type: "checkbox",
                                                                            id: "custom-checkbox",
                                                                            label: "กำหนดค่าเฉลี่ยเอง",
                                                                            disabled: additionalCost.length == 0 || !values.dim_mst_expense_type_id,
                                                                            name: "is_manual_expense",
                                                                            onChange: function(e) {
                                                                                setFieldValue("is_manual_expense", e.currentTarget.checked);
                                                                            },
                                                                            value: values.is_manual_expense,
                                                                            checked: values.is_manual_expense
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mb-4",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-3 pagezoom",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-3 me-3",
                                                style: tab != 1 ? {
                                                    background: "transparent",
                                                    border: 0,
                                                    color: "#9C9C9C"
                                                } : {},
                                                onClick: function() {
                                                    return setTab(1);
                                                },
                                                children: "ข้อมูลสินค้า"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-st-3 me-3",
                                                style: tab != 2 ? {
                                                    background: "transparent",
                                                    border: 0,
                                                    color: "#9C9C9C"
                                                } : {},
                                                onClick: function() {
                                                    return setTab(2);
                                                },
                                                children: "ต้นทุนสินค้า"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(ProductData, {
                                        values: values,
                                        setFieldValue: setFieldValue,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        sumproductPrice: sumproductPrice,
                                        setSumproductPrice: setSumproductPrice,
                                        sumproductNoVat: sumproductNoVat,
                                        setSumproductNoVat: setSumproductNoVat,
                                        sumproductZeroVat: sumproductZeroVat,
                                        setSumproductZeroVat: setSumproductZeroVat,
                                        sumproductSevenVat: sumproductSevenVat,
                                        setSumproductSevenVat: setSumproductSevenVat,
                                        sumproductBeforeVat: sumproductBeforeVat,
                                        setSumproductBeforeVat: setSumproductBeforeVat,
                                        setTotalInDiscoutExVat: setTotalInDiscoutExVat,
                                        optionsWarehouse: optionsWarehouse,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        optionsMstVat: optionsMstVat,
                                        optionNewItemPrCol: optionNewItemPrCol,
                                        columnsort: columnsort,
                                        setColumnsort: setColumnsort,
                                        setFormdata: setFormdata,
                                        setPdata: setPdata,
                                        formdisabled: formdisabled,
                                        setProductReceive: setProductReceive,
                                        setModalProductReceive: setModalProductReceive,
                                        isDiffPO: isDiffPO,
                                        setIsDiffPO: setIsDiffPO,
                                        setSumProductadditionalcosts: setSumProductadditionalcosts,
                                        disabled: tab !== 1,
                                        filterDisplay: filterDisplay,
                                        setFilterDisplay: setFilterDisplay,
                                        columdisplay: columdisplay,
                                        setColumDisplay: setColumDisplay
                                    }),
                                    /*#__PURE__*/ _jsx(ProductCost, {
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        values: values,
                                        totalExpenseExVat: additionalCost.reduce(function(sum, item) {
                                            return sum + (item.total_price_before_vat || 0);
                                        }, 0),
                                        totalInDiscoutExVat: totalInDiscoutExVat,
                                        additionalCost: additionalCost,
                                        setValues: setValues,
                                        sumProductadditionalcosts: sumProductadditionalcosts,
                                        setSumProductadditionalcosts: setSumProductadditionalcosts,
                                        disabled: tab !== 2,
                                        filterDisplay: filterDisplay,
                                        formdisabled: formdisabled,
                                        columdisplay: columdisplay
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("fieldset", {
                                disabled: formdisabled,
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-4 pagezoom",
                                    style: {
                                        minWidth: "1000px"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body px-xl-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "row",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col",
                                                        children: /*#__PURE__*/ _jsx("div", {
                                                            className: "fs-20 fw-bold",
                                                            children: "สรุปข้อมูล"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(sumproductPrice, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "d-flex align-items-center",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "me-2",
                                                                                            children: "ส่วนลด "
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "d-flex align-items-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                                                                    type: "number",
                                                                                                    name: "discount_value",
                                                                                                    className: "form-control",
                                                                                                    placeholder: "",
                                                                                                    value: values.discount_value,
                                                                                                    onChange: function(e) {
                                                                                                        setValues(_object_spread_props(_object_spread({}, values), {
                                                                                                            discount_value: NumberFormatFloat(e.target.value, 4)
                                                                                                        }));
                                                                                                    },
                                                                                                    isInvalid: !!errors.discount_value,
                                                                                                    style: {
                                                                                                        borderRight: 0,
                                                                                                        borderTopRightRadius: 0,
                                                                                                        borderBottomRightRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ _jsx(Select, {
                                                                                                    as: "select",
                                                                                                    name: "dim_mst_discount_type_id",
                                                                                                    onChange: function(e) {
                                                                                                        setFieldValue("dim_mst_discount_type_id", e.value);
                                                                                                    },
                                                                                                    className: "w-100 select-st-2 ".concat(formdisabled ? "pointer-events-none" : ""),
                                                                                                    options: optionsMstDiscountType,
                                                                                                    placeholder: "",
                                                                                                    value: optionsMstDiscountType.filter(function(item) {
                                                                                                        return item.value === values.dim_mst_discount_type_id;
                                                                                                    }),
                                                                                                    style: {
                                                                                                        borderLeft: 0,
                                                                                                        borderTopLeftRadius: 0,
                                                                                                        borderBottomLeftRadius: 0,
                                                                                                        width: "80px"
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx(DiscountInput, {
                                                                                    sumproductPrice: sumproductPrice
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "col-auto",
                                                        children: /*#__PURE__*/ _jsx("table", {
                                                            className: "table table-d1 table-borderless",
                                                            children: /*#__PURE__*/ _jsxs("tbody", {
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้ายกเว้นภาษี"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductNoVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 0 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductZeroVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "มูลค่าสินค้าภาษี 7 %"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true), 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsxs("tr", {
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                className: "text-end",
                                                                                children: "ภาษีมูลค่าเพิ่ม"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fw-bold text-end",
                                                                                    style: {
                                                                                        color: "#636578"
                                                                                    },
                                                                                    children: NumberFormat(WDA(sumproductSevenVat, sumproductBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), true) * 0.07, 2)
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("td", {
                                                                                children: "บาท"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "col-auto",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "mb-3 mt-2",
                                                                children: " มูลค่าสุทธิรวม"
                                                            }),
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "text-white fs-24",
                                                                style: {
                                                                    background: "#FF6B00",
                                                                    padding: "12px 20px",
                                                                    borderRadius: "8px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        children: values.dim_mst_discount_type_id === 1 ? NumberFormat(sumproductPrice * ((100 - values.discount_value) * 0.01), 2) : NumberFormat(sumproductPrice - values.discount_value, 2)
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("span", {
                                                                        className: "fs-14 ms-2",
                                                                        children: "บาท"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "หมายเหตุ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            as: "textarea",
                                                                            rows: 3,
                                                                            name: "remark",
                                                                            value: values.remark,
                                                                            onChange: handleChange
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-6 tag-st-1",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3",
                                                                    controlId: "exampleForm.ControlTextarea1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "fw-bold fs-18",
                                                                            children: "แท็ก"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(TagsInput, {
                                                                            value: tagselected,
                                                                            onChange: setTagSelected,
                                                                            name: "tag",
                                                                            placeHolder: ""
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx("hr", {
                                                        className: "my-4",
                                                        style: {
                                                            opacity: 0.1
                                                        }
                                                    })
                                                ]
                                            }) : "",
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "d-flex justify-content-end align-items-center",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(false);
                                                        },
                                                        disabled: !Collapse,
                                                        children: "ย่อ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        children: "/"
                                                    }),
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn btn-link",
                                                        style: {
                                                            color: "#FF6B00"
                                                        },
                                                        onClick: function() {
                                                            setCollapse(true);
                                                        },
                                                        disabled: Collapse,
                                                        children: "ขยาย"
                                                    })
                                                ]
                                            }),
                                            Collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "fw-bold fs-18 mb-3",
                                                        children: "ไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "pb-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("button", {
                                                                type: "button",
                                                                className: "btn  btn-upload-file mb-4",
                                                                onClick: function(e) {
                                                                    return document.getElementById("fileUpload").click();
                                                                },
                                                                children: "อัพโหลดไฟล์แนบ"
                                                            }),
                                                            /*#__PURE__*/ _jsx("input", {
                                                                type: "file",
                                                                name: "",
                                                                className: "fileUpload hide-input",
                                                                id: "fileUpload",
                                                                accept: ".pdf",
                                                                onChange: function(e) {
                                                                    handlePreviewFile(e);
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "d-flex align-items-center flex-wrap",
                                                                children: attachments.map(function(item, index) {
                                                                    return /*#__PURE__*/ _jsxs("div", {
                                                                        className: "d-flex align-items-center me-3 mb-3",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "me-3",
                                                                                children: index + 1
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("a", {
                                                                                href: "".concat(item.docUrl),
                                                                                target: "_blank",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "docfile",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "icon ".concat(item.docFileType)
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("span", {
                                                                                            className: "name fs-18",
                                                                                            children: item.docFile
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("button", {
                                                                                type: "button",
                                                                                className: "btn  btn-delete-file-cross ms-3",
                                                                                onClick: function(e) {
                                                                                    return deleteDocument(item.id);
                                                                                }
                                                                            })
                                                                        ]
                                                                    }, index);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }) : ""
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4 fixed bottom-0 w-[calc(100%-110px)] drop-shadow",
                                style: {
                                    minWidth: "1000px"
                                },
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        isReadyToPrint(formdisabled, values.dimMstNewStatus ? values.dimMstNewStatus.id : 0) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    style: {
                                                        display: "none"
                                                    },
                                                    children: /*#__PURE__*/ _jsx(PRPrint, {
                                                        innerRef: componentRef,
                                                        values: values
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsxs(Button, {
                                                    type: "button",
                                                    className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                                    onClick: handlePrint,
                                                    disabled: true,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("i", {
                                                            className: "iprinter"
                                                        }),
                                                        "พิมพ์เอกสาร"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs(Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                                            className: "btn btn-st-8 fs-14  px-4",
                                                            id: "dropdown-basic",
                                                            style: {
                                                                backgroundColor: "#565DFF",
                                                                borderColor: "#565DFF",
                                                                height: "40px"
                                                            },
                                                            children: "ตัวเลือก"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                                            className: "p-0 border-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100 ",
                                                                    children: "คัดลอกเอกสาร"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Button, {
                                                                    type: "button",
                                                                    className: "btn-st-6  w-100",
                                                                    children: "ยกเลิกเอกสาร"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/financial-accounting/creditor");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ย้อนกลับ"
                                        }),
                                        isDisabledEditFinancial({
                                            dimMstFinancialStatus: {
                                                id: values.financialStatusID
                                            }
                                        }) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    onClick: function(e) {
                                                        setModalEditFinancial(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true
                                                            });
                                                        });
                                                    },
                                                    className: "bg-[#FDB428] text-white border-[#FDB428] me-3 px-4 btn ",
                                                    disabled: values.financialStatusID === 5,
                                                    children: "ย้อนเป็นรอแก้ไข"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    onClick: function(e) {
                                                        setModalNotApprove(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true
                                                            });
                                                        });
                                                    },
                                                    className: "bg-[#DC0000] text-white border-[#DC0000] me-3 px-4 btn ",
                                                    disabled: values.financialStatusID === 5,
                                                    children: "ยกเลิก"
                                                })
                                            ]
                                        }),
                                        !isDisabledEditFinancial({
                                            dimMstFinancialStatus: {
                                                id: values.financialStatusID
                                            }
                                        }) && /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    className: "w-[200px] h-[44px] me-3 !bg-[#2DC76D] !border-[#2DC76D]",
                                                    onClick: function() {
                                                        return setModalConfirm(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: true
                                                            });
                                                        });
                                                    },
                                                    children: "ยืนยันการตรวจสอบ"
                                                }),
                                                formdisabled && /*#__PURE__*/ _jsx("div", {
                                                    className: "flex items-center justify-end",
                                                    children: /*#__PURE__*/ _jsx(Button, {
                                                        type: "button",
                                                        onClick: function() {
                                                            setFormdisabled(false);
                                                        },
                                                        className: "btn-st-3 me-3",
                                                        disabled: false,
                                                        children: "แก้ไข"
                                                    })
                                                }),
                                                !formdisabled ? /*#__PURE__*/ _jsx("div", {
                                                    className: "flex items-center justify-end",
                                                    children: /*#__PURE__*/ _jsx(Button, {
                                                        className: "w-[150px] h-[44px]",
                                                        onClick: function() {
                                                            return setModalConfirmSave(function(prev) {
                                                                return _object_spread_props(_object_spread({}, prev), {
                                                                    open: true
                                                                });
                                                            });
                                                        },
                                                        children: "บันทึกร่าง"
                                                    })
                                                }) : ""
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "py-5"
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalNotApprove,
                                setModal: setModalNotApprove,
                                htitle: "ยืนยันการเปลี่ยนสถานะ",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-2  tc-10",
                                                    children: "การดำเนินการ"
                                                }),
                                                [
                                                    "radio"
                                                ].map(function(type) {
                                                    return /*#__PURE__*/ _jsxs("div", {
                                                        className: "mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                label: "เปลี่ยนเป็นบันทึกร่าง",
                                                                name: "dim_mst_financial_status_id",
                                                                type: type,
                                                                id: "rs-".concat(type, "-21"),
                                                                className: "form-check-st-2 tc-7",
                                                                onChange: function() {
                                                                    return setFieldValue("dim_mst_financial_status_id", 2);
                                                                },
                                                                value: 2,
                                                                checked: values.dim_mst_financial_status_id === 2,
                                                                isInvalid: !values.dim_mst_financial_status_id
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Check, {
                                                                inline: true,
                                                                label: "ยกเลิกเอกสาร",
                                                                name: "dim_mst_financial_status_id",
                                                                type: type,
                                                                id: "rs-".concat(type, "-22"),
                                                                className: "form-check-st-2 tc-7",
                                                                onChange: function() {
                                                                    return setFieldValue("dim_mst_financial_status_id", 5);
                                                                },
                                                                value: 5,
                                                                checked: values.dim_mst_financial_status_id === 5,
                                                                isInvalid: !values.dim_mst_financial_status_id
                                                            })
                                                        ]
                                                    }, "inline-".concat(type));
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center pb-4 pt-5 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 ms-auto me-3 btn",
                                                    onClick: function() {
                                                        return setModalNotApprove(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalEditFinancial,
                                setModal: setModalEditFinancial,
                                htitle: "ยืนยันการเปลี่ยนสถานะ",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-3 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Form.Label, {
                                                    className: "mb-1",
                                                    children: [
                                                        "เหตุผลการแก้ไข ",
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "text-danger",
                                                            children: "*"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    as: "textarea",
                                                    rows: 5,
                                                    name: "edit_financial_reason",
                                                    onChange: handleChange,
                                                    isInvalid: !values.edit_financial_reason,
                                                    value: values.edit_financial_reason
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center pb-4 pt-5 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 ms-auto me-3 btn",
                                                    onClick: function() {
                                                        return setModalEditFinancial(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    onClick: function() {
                                                        return setFieldValue("dim_mst_financial_status_id", 6);
                                                    },
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalConfirmSave,
                                setModal: setModalConfirmSave,
                                htitle: "ยืนยันการบันทึก",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "font-bold text-center text-[24px]",
                                            children: [
                                                "คุณได้มีการเปลี่ยนแปลงข้อมูล ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                " ยืนยันที่จะบันทึกข้อมูล ใช่หรือไม่"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center justify-center pb-4 pt-4 mt-4 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 me-3 btn",
                                                    onClick: function() {
                                                        return setModalConfirmSave(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    onClick: function(e) {
                                                        setFieldValue("dim_mst_financial_status_id", 2);
                                                    },
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(ModalAllder, {
                                modal: modalConfirm,
                                setModal: setModalConfirm,
                                htitle: "ยืนยันการตรวจสอบ",
                                hbtn: false,
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "py-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "font-bold text-center text-[24px]",
                                            children: [
                                                "คุณต้องการยืนยันการตรวจสอบ ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                " และบันทึกข้อมูล ใช่หรือไม่"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "d-flex align-items-center justify-center pb-4 pt-4 mt-4 ",
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-6 me-3 btn",
                                                    onClick: function() {
                                                        return setModalConfirm(function(prev) {
                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                open: false
                                                            });
                                                        });
                                                    },
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    onClick: function() {
                                                        return setFieldValue("dim_mst_financial_status_id", 3);
                                                    },
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "บันทึก"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSuccess,
                setModal: setModalSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveRequestSuccess,
                setModal: setModalApproveRequestSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "ส่งคำขออนุมัติสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalSaveSuccess,
                setModal: setModalSaveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: "บันทึกสำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalApproveSuccess,
                setModal: setModalApproveSuccess,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4 mt-4 pt-2 pb-2",
                        children: /*#__PURE__*/ _jsx("img", {
                            className: "mx-auto",
                            src: "/images/check.png"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-3",
                        style: {
                            fontSize: "22px",
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "คุณอนุมัติใบขอซื้อ"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-3",
                        style: {
                            fontSize: "22px",
                            color: "#565DFF"
                        },
                        children: "เลขที่ PR-2410000001"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center  mb-2 fw-bold",
                        style: {
                            fontSize: "22px",
                            color: "#636578"
                        },
                        children: "สำเร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalAllder, {
                modal: modalAlert,
                setModal: setModalAlert,
                htitle: "แจ้งเตือน",
                hbtn: false,
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-center pt-4",
                        style: {
                            fontSize: "22px",
                            color: "#2F4858"
                        },
                        children: [
                            "กรุณาเพิ่มรายการสินค้า ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " อย่างน้อย 1 รายการ"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "d-flex align-items-center pb-4 pt-5 ",
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "button",
                            className: "btn-st-3 mx-auto",
                            onClick: function() {
                                return setModalAlert(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยืนยัน"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalProductReceive, {
                modalProductReceive: modalProductReceive,
                setModalProductReceive: setModalProductReceive,
                productReceive: productReceive,
                setProductRow: setProductRow
            }),
            /*#__PURE__*/ _jsx(ModalAdditionalCosts, {
                modal: modalAdditionalCosts,
                setModal: setModalAdditionalCosts,
                additionalCost: additionalCost,
                setAdditionalCost: setAdditionalCost,
                setUpdateExpenseIds: setUpdateExpenseIds
            })
        ]
    });
}
function ProductData(_param) {
    var values = _param.values, setFieldValue = _param.setFieldValue, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionNewItemPrCol = _param.optionNewItemPrCol, productRow = _param.productRow, setProductRow = _param.setProductRow, sumproductPrice = _param.sumproductPrice, setSumproductPrice = _param.setSumproductPrice, sumproductNoVat = _param.sumproductNoVat, setSumproductNoVat = _param.setSumproductNoVat, sumproductZeroVat = _param.sumproductZeroVat, setSumproductZeroVat = _param.setSumproductZeroVat, sumproductSevenVat = _param.sumproductSevenVat, setSumproductSevenVat = _param.setSumproductSevenVat, sumproductBeforeVat = _param.sumproductBeforeVat, setSumproductBeforeVat = _param.setSumproductBeforeVat, columnsort = _param.columnsort, setColumnsort = _param.setColumnsort, setFormdata = _param.setFormdata, setPdata = _param.setPdata, formdisabled = _param.formdisabled, setProductReceive = _param.setProductReceive, setModalProductReceive = _param.setModalProductReceive, isDiffPO = _param.isDiffPO, setIsDiffPO = _param.setIsDiffPO, setTotalInDiscoutExVat = _param.setTotalInDiscoutExVat, setSumProductadditionalcosts = _param.setSumProductadditionalcosts, disabled = _param.disabled, filterDisplay = _param.filterDisplay, setFilterDisplay = _param.setFilterDisplay, columdisplay = _param.columdisplay, setColumDisplay = _param.setColumDisplay, props = _object_without_properties(_param, [
        "values",
        "setFieldValue",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionNewItemPrCol",
        "productRow",
        "setProductRow",
        "sumproductPrice",
        "setSumproductPrice",
        "sumproductNoVat",
        "setSumproductNoVat",
        "sumproductZeroVat",
        "setSumproductZeroVat",
        "sumproductSevenVat",
        "setSumproductSevenVat",
        "sumproductBeforeVat",
        "setSumproductBeforeVat",
        "columnsort",
        "setColumnsort",
        "setFormdata",
        "setPdata",
        "formdisabled",
        "setProductReceive",
        "setModalProductReceive",
        "isDiffPO",
        "setIsDiffPO",
        "setTotalInDiscoutExVat",
        "setSumProductadditionalcosts",
        "disabled",
        "filterDisplay",
        "setFilterDisplay",
        "columdisplay",
        "setColumDisplay"
    ]);
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        productID: "",
                        productCode: "",
                        productName: "",
                        productBarcode: "",
                        supplierCode: "",
                        warehouseID: "",
                        warehouseName: "",
                        productUnit: "",
                        productQty: "",
                        productOrdered: "",
                        ums: "",
                        productStock: "",
                        productPrice: "",
                        discountType: "",
                        discount: "",
                        discountPercent: 0,
                        tax: "",
                        price_before_tax: "",
                        vat: "",
                        note: "",
                        price_after_tax: "",
                        is_checked: false,
                        edit: false
                    }
                ]);
            });
        }
    };
    var checkLength = productRow.filter(function(row) {
        return row.is_checked === true;
    });
    // useEffect(() => {
    //   if (productRow.length <= 0) {
    //     addProductRow(4);
    //   }
    // }, []);
    useEffect(function() {
        if (values.is_one_receiving_point && productRow.length > 0) {
            setProductRow(function(prev) {
                return prev.map(function(pd) {
                    if (pd.productID) {
                        var warehouseID = values.dim_warehouse_id;
                        var warehouse = optionsWarehouse.find(function(item) {
                            return values.dim_warehouse_id === item.value;
                        });
                        var warehouseName = warehouse ? warehouse.label : "";
                        return _object_spread_props(_object_spread({}, pd), {
                            warehouseID: warehouseID,
                            warehouseName: warehouseName
                        });
                    }
                    return _object_spread({}, pd);
                });
            });
        }
    }, [
        values.dim_warehouse_id
    ]);
    var _useState = _sliced_to_array(useState(0), 2), rowCount = _useState[0], setRowCount = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductQty = _useState1[0], setSumproductQty = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumUms = _useState2[0], setSumUms = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumProductOrderQuantity = _useState3[0], setSumProductOrderQuantity = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumProductReceivedQuantity = _useState4[0], setSumProductReceivedQuantity = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumProductReceiveQuantity = _useState5[0], setSumProductReceiveQuantity = _useState5[1];
    var _useState6 = _sliced_to_array(useState(0), 2), sumProductBalanceQuantity = _useState6[0], setSumProductBalanceQuantity = _useState6[1];
    var _useState7 = _sliced_to_array(useState(0), 2), sumProductVat = _useState7[0], setSumProductVat = _useState7[1];
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceBeforeVat = 0;
        var priceNoVat = 0;
        var priceZeroVat = 0;
        var priceSevenVat = 0;
        var priceVat = 0;
        var ums = 0;
        var productOrderQuantity = 0;
        var productReceivedQuantity = 0;
        var productReceiveQuantity = 0;
        var productBalanceQuantity = 0;
        var productadditionalcosts = 0;
        productRow.forEach(function(pd) {
            var orderQuantity = parseInt(pd.productOrderQuantity);
            var receivedQuantity = parseInt(pd.productReceivedQuantity);
            var receiveQty = parseInt(pd.productReceiveQuantity);
            var productQty = parseInt(pd.productQty);
            var productPrice = parseFloat(pd.productPrice);
            var productRatioUnit = parseInt(pd.productRatioUnit);
            var productcosts = parseFloat(pd.exVatTotalAvgDiscount);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            var hasValidOrderQuantity = orderQuantity > 0;
            var hasValidReceivedQuantity = receivedQuantity > 0;
            var hasValidReceiveQty = receiveQty > 0;
            var hasValidproductcosts = productcosts > 0;
            if (hasValidproductcosts) {
                productadditionalcosts += productcosts;
            }
            if (hasValidOrderQuantity) {
                productOrderQuantity += orderQuantity;
            }
            if (hasValidReceivedQuantity) {
                productReceivedQuantity += receivedQuantity;
            }
            if (hasValidReceiveQty) {
                productReceiveQuantity += receiveQty;
            }
            productBalanceQuantity = productOrderQuantity - productReceivedQuantity;
            // Calculate price and priceBeforeVat if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
                ums += productRatioUnit * productQty;
            }
            if (hasValidQty && hasValidPrice) {
                price += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false);
                priceBeforeVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                // Calculate prices based on VAT type
                switch(parseInt(pd.dim_mst_vat_id)){
                    case 1:
                        priceNoVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 2:
                        priceZeroVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    case 3:
                        priceSevenVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
                        break;
                    default:
                        console.log(pd.dim_mst_vat_id);
                        break;
                }
                priceVat += calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(pd, values.dim_mst_price_category_id, true);
            }
        });
        setSumproductPrice(price);
        setSumproductBeforeVat(priceBeforeVat);
        setSumproductNoVat(priceNoVat);
        setSumproductZeroVat(priceZeroVat);
        setSumproductSevenVat(priceSevenVat);
        setSumProductVat(priceVat);
        setSumproductQty(qty);
        setSumUms(ums);
        setSumProductOrderQuantity(productOrderQuantity);
        setSumProductReceivedQuantity(productReceivedQuantity);
        setSumProductReceiveQuantity(productReceiveQuantity);
        setSumProductBalanceQuantity(productBalanceQuantity);
        var totalInDiscoutExVat = NumberFormatFloat(WDA(priceBeforeVat, priceBeforeVat, getDiscountValue(values.dim_mst_discount_type_id, sumproductPrice, values.discount_value), false), 4);
        setTotalInDiscoutExVat(totalInDiscoutExVat);
        setSumProductadditionalcosts(productadditionalcosts);
    };
    useEffect(function() {
        setRowCount(productRow.length);
        sumQty(productRow);
    }, [
        productRow,
        values.dim_mst_price_category_id
    ]);
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 650,
        pin: false,
        mode: "normal",
        modalname: "finan-product-select"
    }), 2), modal = _useState8[0], setModal = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "finan-product-sort"
    }), 2), modalSort = _useState9[0], setModalSort = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "finan-product-display"
    }), 2), modalDisplayColumn = _useState10[0], setModalDisplayColumn = _useState10[1];
    var _useState11 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "finan-product-filter"
    }), 2), modalDisplayFilter = _useState11[0], setModalDisplayFilter = _useState11[1];
    var _useState12 = _sliced_to_array(useState(null), 2), documentType = _useState12[0], setDocumentType = _useState12[1];
    var _useState13 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 670,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState13[0], setModalLoadDocument = _useState13[1];
    var _useState14 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1400,
        height: 700,
        pin: false,
        mode: "normal",
        modalname: "pr-select-document"
    }), 2), modalSelectDocument = _useState14[0], setModalSelectDocument = _useState14[1];
    var _useState15 = _sliced_to_array(useState([]), 2), historyProduct = _useState15[0], setHistoryProduct = _useState15[1];
    var _useState16 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 600,
        pin: false,
        mode: "normal",
        modalname: "product-history"
    }), 2), modalProductHistory = _useState16[0], setModalProductHistory = _useState16[1];
    useEffect(function() {
        var idisplay = localStorage.getItem("columFinandisplay");
        if (idisplay) {
            setColumDisplay(JSON.parse(idisplay));
        }
    }, []);
    var items = useMemo(function() {
        return productRow === null || productRow === void 0 ? void 0 : productRow.map(function(param) {
            var rowID = param.rowID;
            return rowID;
        });
    }, [
        productRow
    ]);
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var _useState17 = _sliced_to_array(useState(false), 2), customSort = _useState17[0], setCustomSort = _useState17[1];
    var _useState18 = _sliced_to_array(useState(), 2), activeId = _useState18[0], setActiveId = _useState18[1];
    function handleDragStart(event) {
        setActiveId(event.active.id);
        var active = event.active, over = event.over;
    // console.log(event)
    }
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {
            setProductRow(function(productRow) {
                var oldIndex = items.indexOf(active.id);
                var newIndex = items.indexOf(over.id);
                return arrayMove(productRow, oldIndex, newIndex);
            });
        }
        setActiveId(null);
    }
    function handleDragCancel() {
        setActiveId(null);
    }
    var selectedRow = useMemo(function() {
        if (!activeId) {
            return null;
        }
        var row = productRow.filter(function(prev) {
            return prev.rowID == activeId;
        });
        return row;
    }, [
        activeId
    ]);
    var checkProductReceived = productRow.filter(function(prev) {
        return prev.productReceivedQuantity > 0;
    });
    // productRow
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                setModalDisplayColumn(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            disabled: false,
                            children: "ตัวเลือกแสดงผล"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-x1 me-2",
                            onClick: function() {
                                return setModalDisplayFilter(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: true
                                    });
                                });
                            },
                            children: "ตัวกรอง"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modal,
                setModal: setModal,
                htitle: "เพิ่มสินค้าหลายรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductSelect, {
                    productRow: productRow,
                    setProductRow: setProductRow,
                    addProductRow: addProductRow,
                    optionsWarehouse: optionsWarehouse,
                    optionsMstVat: optionsMstVat,
                    values: values
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSort,
                setModal: setModalSort,
                htitle: "จัดเรียง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableSort, {
                    columnsort: columnsort,
                    setColumnsort: setColumnsort,
                    columnoption: optionNewItemPrCol,
                    setCustomSort: setCustomSort,
                    setModal: setModalSort,
                    productRow: productRow,
                    setProductRow: setProductRow,
                    setFieldValue: setFieldValue,
                    fieldName: "dim_new_item_pr_sorts"
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayColumn,
                setModal: setModalDisplayColumn,
                htitle: "ตัวเลือกการแสดงผล Financial",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableDisplay, {
                    columdisplay: columdisplay,
                    columdisplayName: "columFinanDisplay",
                    setModalDisplayColumn: setModalDisplayColumn,
                    setColumDisplay: setColumDisplay
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDisplayFilter,
                setModal: setModalDisplayFilter,
                htitle: "ตัวกรอง",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductTableFilterDisplay, {
                    filterDisplay: filterDisplay,
                    filterdisplayName: "filterdisplay",
                    setModalDisplayFilter: setModalDisplayFilter,
                    setFilterDisplay: setFilterDisplay
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalLoadDocument,
                setModal: setModalLoadDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(LoadDocument, {
                    columdisplay: columdisplay,
                    setModal: setModalLoadDocument,
                    setDocumentType: setDocumentType,
                    setModalSelectDocument: setModalSelectDocument,
                    setProductRow: setProductRow,
                    setFormdata: setFormdata,
                    setPdata: setPdata
                })
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalSelectDocument,
                setModal: setModalSelectDocument,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: documentType
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalProductHistory,
                setModal: setModalProductHistory,
                htitle: "ดูประวัติสินค้า",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(ProductHistory, {
                    historyProduct: historyProduct,
                    setModalProductHistory: setModalProductHistory
                })
            }),
            /*#__PURE__*/ _jsx("fieldset", {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "pagezoom",
                    style: {
                        overflowX: "auto",
                        maxWidth: "100%",
                        overflowY: "hidden",
                        paddingBottom: "20px",
                        display: disabled ? "none" : "block"
                    },
                    children: /*#__PURE__*/ _jsx(DndContext, {
                        sensors: sensors,
                        collisionDetection: closestCenter,
                        onDragEnd: handleDragEnd,
                        onDragCancel: handleDragCancel,
                        onDragStart: handleDragStart,
                        modifiers: [
                            restrictToVerticalAxis
                        ],
                        children: /*#__PURE__*/ _jsx(SortableContext, {
                            items: productRow,
                            strategy: verticalListSortingStrategy,
                            children: /*#__PURE__*/ _jsxs("table", {
                                className: "column_resize_table table1 table-striped ",
                                style: {
                                    width: "auto"
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("thead", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {}),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 35
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "รหัสสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    defaultWidth: 200,
                                                    minWidth: 5
                                                }),
                                                columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "บาร์โค้ด"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 100
                                                        })
                                                    ]
                                                }) : "",
                                                columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            children: "รหัสสินค้าผู้ขาย"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer",
                                                            minWidth: 130
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "รายการ"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 250
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "หน่วย"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "",
                                                    children: "จำนวนที่สั่ง"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer ",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                }),
                                                checkProductReceived.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("th", {
                                                            className: "!bg-[#909090]  !text-[#FFF]",
                                                            children: "จำนวนที่รับแล้ว"
                                                        }),
                                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                                            className: "columnResizer !bg-[#909090] !text-white",
                                                            minWidth: 5,
                                                            defaultWidth: 140
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "!bg-[#FF731D] !text-[#FFF] ",
                                                    children: "จำนวนรับครั้งนี้"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer !bg-[#FF731D] !text-[#FFF] ",
                                                    minWidth: 5,
                                                    defaultWidth: 110
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    className: "!bg-[#909090]  !text-[#FFF]",
                                                    children: "จำนวนค้างรับ"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer !bg-[#909090] !text-white",
                                                    minWidth: 5,
                                                    defaultWidth: 140
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "ราคา/หน่วย"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 110
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "ประเภทส่วนลด"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 140
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "ส่วนลด/หน่วย"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 120
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "ภาษี"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 80
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "มูลค่าก่อนภาษี"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "จัดการ LOT"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 120
                                                }),
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "หมายเหตุ"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 5,
                                                    defaultWidth: 100
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("tbody", {
                                        children: productRow.map(function(item, index) {
                                            var _filterDisplay_onlyReceiveProduct;
                                            if (!(filterDisplay === null || filterDisplay === void 0 ? void 0 : (_filterDisplay_onlyReceiveProduct = filterDisplay.onlyReceiveProduct) === null || _filterDisplay_onlyReceiveProduct === void 0 ? void 0 : _filterDisplay_onlyReceiveProduct.isActive) || item.productReceiveQuantity > 0) {
                                                return /*#__PURE__*/ _jsx(Productrow, {
                                                    item: item,
                                                    index: index,
                                                    columdisplay: columdisplay,
                                                    customSort: customSort,
                                                    rowCount: rowCount,
                                                    values: values,
                                                    setProductReceive: setProductReceive,
                                                    setModalProductReceive: setModalProductReceive,
                                                    checkProductReceived: checkProductReceived,
                                                    setProductRow: setProductRow,
                                                    optionsWarehouse: optionsWarehouse,
                                                    optionsMstDiscountType: optionsMstDiscountType,
                                                    optionsMstVat: optionsMstVat,
                                                    setIsDiffPO: setIsDiffPO
                                                }, index);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("tfoot", {
                                        children: /*#__PURE__*/ _jsxs("tr", {
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                checkProductReceived.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                name: "sumProductReceivedQuantity",
                                                                className: "form-control text-center disabled:bg-[#FFFFFF] text-[#061126]",
                                                                placeholder: "",
                                                                value: sumProductReceivedQuantity,
                                                                disabled: true,
                                                                style: {
                                                                    position: "absolute",
                                                                    right: "-0.5vw",
                                                                    top: "10px"
                                                                }
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "sumProductReceiveQuantity",
                                                        className: "form-control text-center disabled:bg-[#FFEDE0] text-[#FF6B00]",
                                                        placeholder: "",
                                                        value: sumProductReceiveQuantity,
                                                        disabled: true,
                                                        style: {
                                                            position: "absolute",
                                                            right: "-0.5vw",
                                                            top: "10px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body "
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                                        type: "text",
                                                        name: "sumproductBalanceQuantity",
                                                        className: "form-control text-center disabled:bg-[#FFFFFF] text-[#FF0000]",
                                                        placeholder: "",
                                                        value: sumProductBalanceQuantity,
                                                        disabled: true,
                                                        style: {
                                                            position: "absolute",
                                                            right: "-0.5vw",
                                                            top: "10px"
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx(FinancialDiffStatus, {
                                                        isDiffPO: isDiffPO
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {}),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, dataID = _param.dataID, setProductReceive = _param.setProductReceive, setModalProductReceive = _param.setModalProductReceive, checkProductReceived = _param.checkProductReceived, setIsDiffPO = _param.setIsDiffPO, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "dataID",
        "setProductReceive",
        "setModalProductReceive",
        "checkProductReceived",
        "setIsDiffPO"
    ]);
    var _useSortable = useSortable({
        id: item.rowID
    }), attributes = _useSortable.attributes, listeners = _useSortable.listeners, setNodeRef = _useSortable.setNodeRef, transform = _useSortable.transform, transition = _useSortable.transition;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(null), 2), anchorEl = _useState[0], setAnchorEl = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), popid = _useState1[0], setPopid = _useState1[1];
    var _item_productPrice, _item_discount;
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                style: customSort ? {
                    paddingLeft: 0
                } : {},
                children: customSort ? /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                    style: {
                        paddingLeft: "14px",
                        transform: CSS.Transform.toString(transform),
                        transition: transition
                    },
                    ref: setNodeRef
                }, attributes, listeners), {
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "btn-drag"
                    })
                })) : /*#__PURE__*/ _jsx("div", {
                    className: "flex items-start ",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mr-1",
                        children: [
                            index + 1,
                            ". "
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productCode
            }),
            columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productBarcode
                    })
                ]
            }) : "",
            columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        children: item.supplierCode
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!text-left",
                children: item.productName
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: !!item.productUnit && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        item.productUnit,
                        /*#__PURE__*/ _jsx("br", {}),
                        "1X",
                        item.productRatioUnit
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "",
                children: item.productOrderQuantity
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body "
            }),
            checkProductReceived.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: " !text-[#061126]",
                        children: item.productReceivedQuantity
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body  !text-[#061126]"
                    })
                ]
            }) : "",
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#FFEDE0] !text-[#FF731D]",
                children: item.productReceiveQuantity
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#FFEDE0] !text-[#FF731D]"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: " !text-[#DC0000]",
                children: item.productOrderQuantity - item.productReceivedQuantity
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body  !text-[#DC0000]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx(CurrencyInput, {
                    placeholder: "",
                    defaultValue: (_item_productPrice = item.productPrice) !== null && _item_productPrice !== void 0 ? _item_productPrice : 0,
                    value: item.productPrice,
                    decimalsLimit: 4,
                    // fixedDecimalLength={2}
                    decimalScale: 4,
                    onValueChange: function(value, name, values) {
                        // console.log(value);
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        productPrice: value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control formv text-end me-2"
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsxs("td", {
                className: "position-reative",
                id: "pop".concat(index),
                children: [
                    /*#__PURE__*/ _jsxs("button", {
                        className: "btn w-100 btn-nhover",
                        type: "button",
                        id: "idd".concat(index),
                        style: {
                            height: "34px"
                        },
                        variant: "contained",
                        onClick: function(e) {
                            setPopid("sss2".concat(index));
                            setAnchorEl(e.currentTarget);
                        },
                        children: [
                            item.productID && (item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx(_Fragment, {
                                children: item.discountType == 1 ? "".concat(item.discountPercent, " %") : item.discountType == 2 ? "บาท" : ""
                            }),
                            item.productID && !(item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx("div", {
                                style: {
                                    color: "#565DFF"
                                },
                                children: "เลือกส่วนลด"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Popover, {
                        id: "sss2".concat(index),
                        open: "sss2".concat(index) == popid,
                        anchorEl: anchorEl,
                        onClose: function() {
                            setAnchorEl(null);
                            setPopid(null);
                        },
                        anchorPosition: {
                            left: 0,
                            top: 0
                        },
                        container: document.getElementById("pop".concat(index)),
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "p-3 text-start ",
                            style: {
                                width: "260px",
                                height: "160px"
                            },
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-3",
                                    children: "เลือกรูปแบบส่วนลด"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mb-2 d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ _jsx(Form.Check, {
                                            inline: true,
                                            label: "เปอร์เซ็นต์ %",
                                            name: "",
                                            type: "radio",
                                            id: "x-radio-2".concat(index),
                                            className: "form-check-st-2 tc-7",
                                            checked: item.discountType == 1,
                                            onChange: function(e) {
                                                setProductRow(function(prev) {
                                                    return prev.map(function(el) {
                                                        if (el.rowID === item.rowID) {
                                                            return _object_spread_props(_object_spread({}, el), {
                                                                discountType: 1,
                                                                discount: el.productPrice * parseFloat(el.discountPercent) / 100
                                                            });
                                                        }
                                                        return el;
                                                    });
                                                });
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Form.Control, {
                                            type: "number",
                                            name: "",
                                            className: "form-control text-center",
                                            placeholder: "",
                                            value: item.discountPercent,
                                            style: {
                                                width: "60px"
                                            },
                                            onChange: function(e) {
                                                setProductRow(function(prev) {
                                                    return prev.map(function(el) {
                                                        if (el.rowID === item.rowID) {
                                                            return _object_spread_props(_object_spread({}, el), {
                                                                discountPercent: e.target.value,
                                                                discount: el.productPrice * parseFloat(e.target.value) / 100
                                                            });
                                                        }
                                                        return el;
                                                    });
                                                });
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    children: /*#__PURE__*/ _jsx(Form.Check, {
                                        inline: true,
                                        label: "บาท",
                                        name: "",
                                        type: "radio",
                                        id: "x-radio-1".concat(index),
                                        className: "form-check-st-2 tc-7",
                                        checked: item.discountType == 2,
                                        onChange: function(e) {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            discountType: 2
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "text-end",
                children: item.discountType == 1 ? /*#__PURE__*/ _jsx(NumericFormat, {
                    displayType: "text",
                    thousandSeparator: ",",
                    decimalScale: 4,
                    fixedDecimalScale: true,
                    value: item.productPrice * parseFloat(item.discountPercent) / 100
                }) : item.discountType == 2 ? /*#__PURE__*/ _jsx(CurrencyInput, {
                    placeholder: "",
                    defaultValue: (_item_discount = item.discount) !== null && _item_discount !== void 0 ? _item_discount : 0,
                    value: values.discount,
                    decimalsLimit: 4,
                    // fixedDecimalLength={2}
                    decimalScale: 4,
                    onValueChange: function(value, name, values) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        discount: value
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control formv text-end me-2"
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.productID ? /*#__PURE__*/ _jsx("select", {
                    value: item.dim_mst_vat_id,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var vat = optionsMstVat.find(function(v) {
                                        return v.value == e.currentTarget.value;
                                    });
                                    vat = vat ? vat.vat : 0;
                                    return _object_spread_props(_object_spread({}, el), {
                                        dim_mst_vat_id: e.currentTarget.value,
                                        vat: vat
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: optionsMstVat && optionsMstVat.map(function(v, index) {
                        return /*#__PURE__*/ _jsx("option", {
                            value: v.value,
                            children: v.label
                        }, index);
                    })
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "text-end",
                children: item.productPrice ? /*#__PURE__*/ _jsx(FinancialTotal, {
                    totalPrice: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true),
                    poSplitPrice: getTotalPriceWithNewQty(item.poSplitTotalBeforeVat, item.productOrderQuantity, item.productQty),
                    setIsDiffPO: setIsDiffPO
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body  !text-[#DC0000]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsxs(Button, {
                    className: "!bg-transparent !text-[#080808] hover:!text-[#666CFF] hover:!bg-transparent  border-0 flex items-center",
                    onClick: function() {
                        setProductReceive(item);
                        setModalProductReceive(function(prev) {
                            return _object_spread_props(_object_spread({}, prev), {
                                open: true
                            });
                        });
                    },
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: " h-[24px] w-[24px] block rounded-full pb-1  bg-[#FF6B00] mr-2",
                            children: /*#__PURE__*/ _jsx(VisibilityIcon, {
                                className: "text-[#FFF] !text-[16px] mt-[-2px] "
                            })
                        }),
                        " ",
                        "ดู Lot"
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.note
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
function ProductCost(param) {
    var productRow = param.productRow, setProductRow = param.setProductRow, values = param.values, totalExpenseExVat = param.totalExpenseExVat, totalInDiscoutExVat = param.totalInDiscoutExVat, additionalCost = param.additionalCost, setValues = param.setValues, sumProductadditionalcosts = param.sumProductadditionalcosts, setSumProductadditionalcosts = param.setSumProductadditionalcosts, disabled = param.disabled, filterDisplay = param.filterDisplay, formdisabled = param.formdisabled, columdisplay = param.columdisplay;
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    function handleDragEnd(event) {
        var active = event.active, over = event.over;
        if (active.id !== over.id) {}
    }
    function handleDragCancel() {}
    var _useState = _sliced_to_array(useState(0), 2), sumProductOrderQuantity = _useState[0], setSumProductOrderQuantity = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumProductReceivedQuantity = _useState1[0], setSumProductReceivedQuantity = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumProductReceiveQuantity = _useState2[0], setSumProductReceiveQuantity = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumProductBalanceQuantity = _useState3[0], setSumProductBalanceQuantity = _useState3[1];
    var sumQty = function(productRow) {
        var productadditionalcosts = 0;
        var productOrderQuantity = 0;
        var productReceivedQuantity = 0;
        var productReceiveQuantity = 0;
        var productBalanceQuantity = 0;
        productRow.forEach(function(pd) {
            var orderQuantity = parseInt(pd.productOrderQuantity);
            var receivedQuantity = parseInt(pd.productReceivedQuantity);
            var receiveQty = parseInt(pd.productReceiveQuantity);
            var hasValidOrderQuantity = orderQuantity > 0;
            var hasValidReceivedQuantity = receivedQuantity > 0;
            var hasValidReceiveQty = receiveQty > 0;
            var productcosts = parseFloat(pd.exVatTotalAvgDiscount);
            var hasValidproductcosts = productcosts > 0;
            if (hasValidOrderQuantity) {
                productOrderQuantity += orderQuantity;
            }
            if (hasValidReceivedQuantity) {
                productReceivedQuantity += receivedQuantity;
            }
            if (hasValidReceiveQty) {
                productReceiveQuantity += receiveQty;
            }
            if (hasValidproductcosts) {
                productadditionalcosts += productcosts;
            }
            productBalanceQuantity = productOrderQuantity - productReceivedQuantity;
        });
        setSumProductOrderQuantity(productReceiveQuantity);
        setSumProductReceivedQuantity(productReceiveQuantity);
        setSumProductReceiveQuantity(productReceiveQuantity);
        setSumProductBalanceQuantity(productBalanceQuantity);
        setSumProductadditionalcosts(productadditionalcosts);
    };
    var calExpenseAvg = function() {
        if (additionalCost && additionalCost.length === 0) {
            setValues(_object_spread_props(_object_spread({}, values), {
                dim_mst_expense_type_id: "",
                is_manual_expense: false
            }));
        }
        setProductRow(function(prev) {
            return prev.map(function(item) {
                var totalUnitPrice = calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true);
                var tmpExVatTotalAvgDiscount = getExVatAvgPriceByExpenseType({
                    unitTotalPrice: totalUnitPrice,
                    unitTotalQty: item.productQty,
                    totalPrice: totalInDiscoutExVat,
                    totalQty: sumProductReceiveQuantity,
                    totalExpenseExVat: totalExpenseExVat,
                    mstExpenseTypeID: values.dim_mst_expense_type_id
                });
                return _object_spread_props(_object_spread({}, item), {
                    exVatTotalAvgDiscount: values.is_manual_expense && item.initExVatTotalAvgDiscount > 0 ? item.initExVatTotalAvgDiscount : tmpExVatTotalAvgDiscount
                });
            });
        });
    };
    useEffect(function() {
        // console.log(productRow);
        sumQty(productRow);
    }, [
        productRow
    ]);
    useEffect(function() {
        // console.log(values.dim_mst_expense_type_id);
        calExpenseAvg();
    }, [
        values.dim_mst_expense_type_id,
        totalExpenseExVat,
        values.is_manual_expense
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "pagezoom",
            style: {
                overflowX: "auto",
                maxWidth: "100%",
                overflowY: "hidden",
                paddingBottom: "20px",
                display: disabled ? "none" : "block"
            },
            children: /*#__PURE__*/ _jsx(DndContext, {
                sensors: sensors,
                collisionDetection: closestCenter,
                onDragEnd: handleDragEnd,
                onDragCancel: handleDragCancel,
                onDragStart: function() {},
                modifiers: [
                    restrictToVerticalAxis
                ],
                children: /*#__PURE__*/ _jsx(SortableContext, {
                    items: [],
                    strategy: verticalListSortingStrategy,
                    children: /*#__PURE__*/ _jsxs("table", {
                        className: "column_resize_table table1 table-striped ",
                        style: {
                            width: "auto"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("thead", {
                                children: /*#__PURE__*/ _jsxs("tr", {
                                    children: [
                                        /*#__PURE__*/ _jsx("th", {}),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer",
                                            minWidth: 5,
                                            defaultWidth: 35
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "รหัสสินค้า"
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer",
                                            defaultWidth: 160,
                                            minWidth: 5
                                        }),
                                        columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "บาร์โค้ด"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    defaultWidth: 160,
                                                    minWidth: 5
                                                })
                                            ]
                                        }) : "",
                                        columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                            children: [
                                                /*#__PURE__*/ _jsx("th", {
                                                    children: "รหัสสินค้าผู้ขาย"
                                                }),
                                                /*#__PURE__*/ _jsx(ColumnResizer, {
                                                    className: "columnResizer",
                                                    minWidth: 130
                                                })
                                            ]
                                        }) : "",
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "รายการ"
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer",
                                            minWidth: 5,
                                            defaultWidth: 250
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            children: "หน่วย"
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer",
                                            minWidth: 5,
                                            defaultWidth: 100
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "",
                                            children: "จำนวนรับ"
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer ",
                                            minWidth: 5,
                                            defaultWidth: 100
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "!bg-[#FF731D] !text-[#FFF] ",
                                            children: [
                                                "ราคาต่อหน่วย",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "(Ex.VAT)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer !bg-[#FF731D] !text-[#FFF] ",
                                            minWidth: 5,
                                            defaultWidth: 130
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "",
                                            children: [
                                                "ค่าใช้จ่ายเพิ่มเติม",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "ต่อรายการ (Ex.VAT)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer",
                                            minWidth: 5,
                                            defaultWidth: 130
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            children: [
                                                "ค่าใช้จ่ายเพิ่มเติม ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                " ต่อหน่วย (Ex.VAT)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer",
                                            minWidth: 5,
                                            defaultWidth: 130
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "!bg-[#FF0000] !text-[#FFF]",
                                            children: [
                                                "ต้นทุนรวมต่อรายการ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "(Ex.VAT)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer !bg-[#FF0000]",
                                            minWidth: 5,
                                            defaultWidth: 140
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "!bg-[#10B02A] !text-[#FFF]",
                                            children: [
                                                "ราคาขายต่อหน่วย",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "(Ex.VAT)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer !bg-[#10B02A]",
                                            minWidth: 5,
                                            defaultWidth: 120
                                        }),
                                        /*#__PURE__*/ _jsx("th", {
                                            className: "!bg-[#10B02A] !text-[#FFF] ",
                                            children: "% GP"
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer  !bg-[#10B02A] !text-[#FFF]",
                                            minWidth: 5,
                                            defaultWidth: 80
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "!bg-[#FF0000] !text-[#FFF]",
                                            children: [
                                                "ต้นทุนรวม UMS",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "(Ex.VAT)"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer !bg-[#FF0000]",
                                            minWidth: 5,
                                            defaultWidth: 140
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "!bg-[#10B02A] !text-[#FFF]",
                                            children: [
                                                "ราคาขาย UMS",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                "Ex.VAT"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer !bg-[#10B02A]",
                                            minWidth: 5,
                                            defaultWidth: 120
                                        }),
                                        /*#__PURE__*/ _jsxs("th", {
                                            className: "!bg-[#10B02A] !text-[#FFF] ",
                                            children: [
                                                "UMS ",
                                                /*#__PURE__*/ _jsx("br", {}),
                                                " % GP"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(ColumnResizer, {
                                            className: "columnResizer  !bg-[#10B02A] !text-[#FFF]",
                                            minWidth: 5,
                                            defaultWidth: 80
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("tbody", {
                                children: productRow && productRow.map(function(item, index) {
                                    var _filterDisplay_onlyReceiveProduct;
                                    if (!(filterDisplay === null || filterDisplay === void 0 ? void 0 : (_filterDisplay_onlyReceiveProduct = filterDisplay.onlyReceiveProduct) === null || _filterDisplay_onlyReceiveProduct === void 0 ? void 0 : _filterDisplay_onlyReceiveProduct.isActive) || item.productReceiveQuantity > 0) {
                                        var exVatPriceByMstCategory = calPriceByMstCategoryPriceTaxSeparate(item.productPrice, 0, values.dim_mst_price_category_id, 1, item.vat, true);
                                        var exVatWithDiscount = exVatPriceByMstCategory - (item.discount || 0);
                                        var exVatTotalCost = exVatWithDiscount + safeDivide(item.exVatTotalAvgDiscount, item.productQty);
                                        var gp = getGP(exVatTotalCost, item.productMstPriceBeforeVat);
                                        var exVatUmsTotalCost = safeDivide(exVatTotalCost, item.productRatioUnit);
                                        var exVatUmsMstCost = item.exVatProductUms;
                                        var umsGp = getGP(exVatUmsTotalCost, exVatUmsMstCost);
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "flex items-start ",
                                                        children: /*#__PURE__*/ _jsxs("div", {
                                                            className: "mr-1",
                                                            children: [
                                                                index + 1,
                                                                ". "
                                                            ]
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: item.productCode
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                columdisplay.barcode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: item.productBarcode
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        })
                                                    ]
                                                }) : "",
                                                columdisplay.supplierCode ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx("td", {
                                                            children: item.supplierCode
                                                        }),
                                                        /*#__PURE__*/ _jsx("td", {
                                                            className: "column_resizer_body"
                                                        })
                                                    ]
                                                }) : "",
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "!text-left",
                                                    children: item.productName
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    children: !!item.productUnit && /*#__PURE__*/ _jsxs(_Fragment, {
                                                        children: [
                                                            item.productUnit,
                                                            /*#__PURE__*/ _jsx("br", {}),
                                                            "1X",
                                                            item.productRatioUnit
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "",
                                                    children: item.productReceiveQuantity
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body "
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "!bg-[#FFEDE0]",
                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 4,
                                                        fixedDecimalScale: true,
                                                        value: calPriceByMstCategoryPriceTaxSeparate(item.productPrice, 0, values.dim_mst_price_category_id, 1, item.vat, true)
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body !bg-[#FFEDE0]"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "",
                                                    children: /*#__PURE__*/ _jsx(CurrencyInput, {
                                                        placeholder: "",
                                                        defaultValue: item.exVatTotalAvgDiscount || 0,
                                                        value: item.exVatTotalAvgDiscount,
                                                        decimalsLimit: 4,
                                                        // fixedDecimalLength={2}
                                                        decimalScale: 4,
                                                        onValueChange: function(value, name, values) {
                                                            // console.log(value);
                                                            setProductRow(function(prev) {
                                                                return prev.map(function(el) {
                                                                    if (el.rowID === item.rowID) {
                                                                        return _object_spread_props(_object_spread({}, el), {
                                                                            exVatTotalAvgDiscount: parseFloat(value || 0),
                                                                            initExVatTotalAvgDiscount: parseFloat(value || 0)
                                                                        });
                                                                    }
                                                                    return el;
                                                                });
                                                            });
                                                        },
                                                        className: "form-control formv text-end me-2",
                                                        disabled: !values.is_manual_expense || formdisabled
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body "
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "",
                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 4,
                                                        fixedDecimalScale: true,
                                                        value: safeDivide(item.exVatTotalAvgDiscount, item.productQty)
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body "
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "!bg-[#ffe1e0]",
                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 4,
                                                        fixedDecimalScale: true,
                                                        value: exVatTotalCost
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body !bg-[#ffe1e0]"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "!bg-[#E3FFE0]",
                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 4,
                                                        fixedDecimalScale: true,
                                                        value: item.productMstPriceBeforeVat
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body !bg-[#E3FFE0]"
                                                }),
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: gp < 0 || gp === "error" ? "!bg-[#ffe1e0]" : "!bg-[#E3FFE0] ",
                                                    children: [
                                                        item.productPrice !== 0 && gp !== "error" && /*#__PURE__*/ _jsx(NumericFormat, {
                                                            displayType: "text",
                                                            thousandSeparator: ",",
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true,
                                                            value: gp,
                                                            suffix: "%"
                                                        }),
                                                        item.productPrice === 0 && gp !== "error" && "-",
                                                        gp === "error" && "Error"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: gp < 0 || gp === "error" ? "column_resizer_body !bg-[#ffe1e0]" : "column_resizer_body !bg-[#E3FFE0]"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "!bg-[#ffe1e0]",
                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 4,
                                                        fixedDecimalScale: true,
                                                        value: exVatUmsTotalCost
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body  !bg-[#ffe1e0]"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "!bg-[#E3FFE0]",
                                                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                                                        displayType: "text",
                                                        thousandSeparator: ",",
                                                        decimalScale: 4,
                                                        fixedDecimalScale: true,
                                                        value: exVatUmsMstCost
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "column_resizer_body !bg-[#E3FFE0]"
                                                }),
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: umsGp < 0 || umsGp === "error" ? "!bg-[#ffe1e0]" : "!bg-[#E3FFE0] ",
                                                    children: [
                                                        item.productPrice !== 0 && umsGp !== "error" && /*#__PURE__*/ _jsx(NumericFormat, {
                                                            displayType: "text",
                                                            thousandSeparator: ",",
                                                            decimalScale: 2,
                                                            fixedDecimalScale: true,
                                                            value: umsGp,
                                                            suffix: "%"
                                                        }),
                                                        item.productPrice === 0 && umsGp !== "error" && "-",
                                                        umsGp === "error" && "Error"
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: umsGp < 0 || umsGp === "error" ? "column_resizer_body !bg-[#ffe1e0]" : "column_resizer_body !bg-[#E3FFE0]"
                                                })
                                            ]
                                        });
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsxs("tfoot", {
                                children: [
                                    /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "sumProductReceiveQuantity",
                                                    className: "form-control text-center disabled:bg-[#FFFFFF] text-[#636578]",
                                                    placeholder: "",
                                                    value: sumProductReceiveQuantity,
                                                    disabled: true,
                                                    style: {
                                                        position: "absolute",
                                                        right: "-0.5vw",
                                                        top: "10px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "sumproductBalanceQuantity",
                                                    className: "form-control text-center disabled:bg-[#FFFFFF] text-[#636578]",
                                                    placeholder: "",
                                                    value: sumProductadditionalcosts.toFixed(2),
                                                    disabled: true,
                                                    style: {
                                                        position: "absolute",
                                                        right: "-0.5vw",
                                                        top: "10px"
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(DiffStatus, {
                                                    isDiff: NumberFormatFloat(sumProductadditionalcosts, 4) !== NumberFormatFloat(totalExpenseExVat, 4),
                                                    wrongMsg: "ค่าใช้จ่ายไม่ตรงกัน",
                                                    correctMsg: "ค่าใช้จ่ายตรงกัน"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}
